<template>
	<div class="add">
		<div class="user_info d-flex flex-wrap j-sb a-center">
			<div class="d-flex j-center a-center" style="font-size: 0.75rem;width: 50%;">
				<span>用户名称：</span>
				<input type="text" v-model="user_info.admin_name" placeholder="请输入登录名称"
					style="outline: none;border: 2px solid #1E69FF;border-radius: 4px;width: 16.82rem;height: 1.69rem;padding: 0 0.88rem;">
			</div>
			<div class="d-flex j-center a-center" style="font-size: 0.75rem;width: 50%;">
				<span>用户职位：</span>
				<input type="text" v-model="user_info.identity" placeholder="请输入用户职位"
					style="outline: none;border: 2px solid #1E69FF;border-radius: 4px;width: 16.82rem;height: 1.69rem;padding: 0 0.88rem;">
			</div>
			<div class="d-flex j-center a-center" style="font-size: 0.75rem;width: 50%;">
				<span>登录密码：</span>
				<input type="text" v-model="user_info.password" placeholder="请输入登录密码"
					style="outline: none;border: 2px solid #1E69FF;border-radius: 4px;width: 16.82rem;height: 1.69rem;padding: 0 0.88rem;">
			</div>
			<div class="d-flex j-center a-center" style="font-size: 0.75rem;width: 50%;">
				<span>联系电话：</span>
				<input type="text" v-model="user_info.tel" placeholder="请输入联系电话"
					style="outline: none;border: 2px solid #1E69FF;border-radius: 4px;width: 16.82rem;height: 1.69rem;padding: 0 0.88rem;">
			</div>
		</div>
		<div class="d-flex flex-wrap j-sb a-center">
			<div class="brand_fixture select" v-for="(item,index) in options_arr">
				<el-checkbox :indeterminate="item.isIndeterminate" v-model="item.check_all"
					@change="handleCheckAllChange($event,index)">
					{{item.tag}}<img src="../../assets/authority/biaoshi@2x.png" alt=""
						style="1.19rem;height: 0.81rem;margin-left: 0.25rem;">
				</el-checkbox>
				<el-checkbox-group v-model="item.checked" @change="handleCheckedChange($event,index)" style="margin-top: 1.03rem;">
					<el-checkbox v-for="option in item.options" :label="option" :key="option"
						style="width: 33.3%;margin: 0;">
						{{option}}
					</el-checkbox>
				</el-checkbox-group>
			</div>
		</div>
		<footer class="d-flex j-center a-center">
			<el-checkbox :indeterminate="isIndeterminate_all" v-model="check_all"
				@change="handleCheckAllChange($event,null)">
				全选
			</el-checkbox>
			<el-button round style="margin-left: 3.31rem; width: 9.38rem;height: 1.88rem;color: #FFFFFF;
			font-size: 0.75rem; outline: none;border: none;padding: 0; background: #1E69FF;"
			@click="saveData()">
				保存</el-button>
		</footer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				check_all: false,
				isIndeterminate_all: true,
				options_arr: [],
				user_info: {
					admin_name: '',
					identity: '',
					password: '',
					tel: ''
				},
			};
		},
		methods: {
			brand_role_list(){
				let params = {
					act:'brand_role_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
				}
				this.$api.brand_role_list(params).then((res)=>{
					if(res.code == 0){
						res.data.forEach((item,index)=>{
							this.options_arr.push({
								tag: item.action_name,
								id:item.id,
								checked: [],
								options: [],
								optionsid:[],
								check_all: false,
								isIndeterminate: true
							})
							item.son.forEach((v)=>{
								this.options_arr[index].options.push(v.action_name)
								this.options_arr[index].optionsid.push(v.id)
							})
						})
					}
				})
			},
			handleCheckAllChange(value, index) {
				if (index == null) {
					this.options_arr.forEach((el) => {
						el.check_all = value
						el.checked = value ? el.options : [];
						el.isIndeterminate = false;
					})
					this.isIndeterminate_all = false;
				} else {
					this.options_arr[index].checked = value ? this.options_arr[index].options : [];
					this.options_arr[index].isIndeterminate = false;
				}
			},
			handleCheckedChange(value, index) {
				let checkedCount = value.length;
				this.options_arr[index].check_all = checkedCount === this.options_arr[index].options.length;
				this.options_arr[index].isIndeterminate = checkedCount > 0 && checkedCount < this.options_arr[index].options.length;
			},
			saveData(){
				let arr = []
				this.options_arr.forEach((item)=>{
					if(item.checked.length){
						arr = arr.concat(item.checked)
					}
				})
				let ids = []
				this.options_arr.forEach((item,index)=>{
					item.options.forEach((v,k)=>{
						arr.forEach((val,ky)=>{
							if(v == val){
								ids.push(this.options_arr[index].optionsid[k])
							}
						})
					})
				})
				
				if(this.user_info.admin_name == ''){
					this.$message({
						showClose: false,
						message: '用户名称不能为空',
						type: 'error',
						offset: 350
					})
					return
				}
				if(this.user_info.password == ''){
					this.$message({
						showClose: false,
						message: '密码不能为空',
						type: 'error',
						offset: 350
					})
					return
				}
				
				let params = {
					act:'add_admin_user',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					...this.user_info,
					brand_role_ids:ids.join(',')
				}
				this.$api.add_admin_user(params).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: '添加成功',
							type: 'success',
							offset: 350
						})
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'success',
							offset: 350
						})
					}
				})
			}
		},
		mounted() {
			this.brand_role_list()
		}
	};
</script>

<style lang="scss" scoped>
	.add {
		@mixin common {
			background: #FFFFFF;
			border-radius: 6px;
			box-sizing: border-box;
		}

		height: 100%;
		max-width: 73.24rem;
		margin: 0 auto;
		padding: 1.25rem 0;

		.user_info {
			@include common;
			width: 100%;
			height: 9.38rem;
		}

		.select {
			@include common;
			margin-top: 0.94rem;
			width: calc(50% - 0.47rem);
			height: 10.88rem;
			padding: 1.31rem 2.38rem;
		}

		footer {
			width: 46.87rem;
			height: 3.75rem;
			margin: 0 auto;
			margin-top: 2.44rem;
			background: linear-gradient(to right, #F4F4F4 0%, #FFFFFF 50%, #F4F4F4 100%);
		}
	}
</style>
